
export const initialState = {
    toggle: true,
    user: null,
    notify: null,
    searchText: null,
    showInfo: true,
    showSearchBar: false,
    showModals: false,
    locateMe: false,
};


const reducer = (state, action) => {
    // console.log("Reducer: ", action )
    switch(action.type){

        // TOGGLE_DARK/LIGHT MODE:
        case 'TOGGLE_MODE':
            return {
                ...state,
                toggle: action.toggle
            }

      
        // Global Notification:
        case 'SET_NOTIFY':
            return {
                ...state,
                notify : action.notify
            }

     

        // Add User:
        case 'ADD_USER':
            return {
                ...state,
                user: action.user
            }


        // Search Bar Text:
        case 'SEARCH_TEXT':
            return{
                ...state,
                searchText : action.searchText
            }

        // Show Information of Galaxy:
        case 'SHOW_INFO':
            return{
                ...state,
                showInfo : action.showInfo
            }

        // Search Bar Text:
        case 'SHOW_SEARCH':
            return{
                ...state,
                showSearchBar : action.showSearchBar
            }

            // Search Bar Text:
        case 'SHOW_MODALS':
            return{
                ...state,
                showModals : action.showModals
            }

            // Search Bar Text:
        case 'LOCATE_ME':
            return{
                ...state,
                locateMe : action.locateMe
            }
        

       

        // Default:
        default:
            return state;
    }
}


export default reducer;